/**
 * @export
 * @class Basket
 */
import { BaseModule } from '../../helpers/base_module';

import { ProtectChanges } from './protect-changes';

export class Basket extends BaseModule {
    public static id = 'basket';

    constructor() {
        super();

        new ProtectChanges();
    }
}
